import { buildPrompt } from '@/ai/utils/promptBuilder'
import { createUserMessage } from '@/ai/utils/promptUtils'
import { examples, getEventExample } from '@/ai/prompts/common/examples'
import { getJsonArrayOutputFormatting } from '@/ai/prompts/common/formatting'

export const buildWorkflowWriteModelsPrompt = ({ workflow, cardTypes }) => {
  const messages = []
  const promptSections = []

  promptSections.push({
    title: 'Request',
    content: `
      For each step, create a set of input fields. You are designing simple input forms
      (or mockups or wireframes) with data fields to be filled in and submitted by the actor (or role),
      in order to invoke a command on an aggregate, for each step of the process.
      Each data field is an input field that the user (or system, if automated) can fill in.
      The form reflects the information requested from the actor in order to invoke the command on the aggregate.
      The number of input fields per step can vary, but it is usually between 4 and 8.
      A data field name must be at most 30 characters long.
    `
  })

  const formattingContent = `The resulting array must contain ${workflow.eventsJson.length} items.`

  const options = {
    shouldAddCards: false,
    shouldAddDataModels: true
  }

  const exampleData1 = {
    role: 'Role description',
    description: 'Created order',
    commandExample: examples.commandExampleCreateOrder
  }
  const exampleData2 = {
    role: 'Role description',
    description: 'Resolved issue',
    commandExample: examples.commandExampleDeliverOrder
  }

  const eventsExample = [
    getEventExample(exampleData1, cardTypes, null, options),
    getEventExample(exampleData2, cardTypes, null, options)
  ]

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonArrayOutputFormatting(JSON.stringify(eventsExample), formattingContent)

  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
